module.exports = __webpack_public_path__ + "static/media/sorbetes.e393b992.jpg";